import { render, staticRenderFns } from "./A103.vue?vue&type=template&id=85750c22&scoped=true"
import script from "./A103.vue?vue&type=script&lang=js"
export * from "./A103.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=85750c22&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85750c22",
  null
  
)

export default component.exports